var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.94 12 3 19.94 4.06 21 12 13.06 19.94 21 21 19.94 13.06 12 21 4.06 19.94 3 12 10.94 4.06 3 3 4.061l7.94 7.94Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m3 19.94-.177-.177-.177.176.177.177zM10.94 12l.176.177.177-.177-.177-.177zm-6.88 9-.176.177.177.177.176-.177L4.061 21ZM12 13.06l.177-.176-.177-.177-.177.177zM19.94 21l-.177.177.176.176.177-.176zM21 19.94l.177.176.177-.177-.177-.177-.177.177ZM13.06 12l-.176-.177-.177.177.177.177zM21 4.06l.177.177.177-.176-.177-.177zM19.94 3l.176-.177-.177-.177-.176.177.176.177ZM12 10.94l-.177.176.177.177.177-.177zM4.06 3l.178-.176-.177-.177-.177.177.177.176ZM3 4.061l-.177-.177-.176.177.176.177L3 4.06Zm.177 16.055 7.94-7.94-.354-.353-7.94 7.94zm1.06.707-1.06-1.06-.354.353 1.06 1.06zm7.586-7.939-7.94 7.94.354.353 7.94-7.94zm8.293 7.94-7.94-7.94-.353.354 7.94 7.939.353-.354Zm.707-1.062-1.06 1.061.353.354 1.06-1.061zm-7.94-7.585 7.94 7.939.354-.354-7.94-7.939zm7.94-8.293-7.94 7.94.354.353 7.94-7.94zm-1.06-.707 1.06 1.06.354-.353-1.06-1.06zm-7.586 7.94 7.94-7.94-.354-.354-7.94 7.94zm-8.293-7.94 7.94 7.94.353-.354-7.94-7.94zm-.707 1.06 1.06-1.06-.353-.353-1.06 1.06zm7.94 7.586-7.94-7.939-.354.354 7.94 7.939z"
  })));
};
export default SvgClose;